export const CHANGE_COLLAPSIBLE_VaLUE = 'OpenedCollapsable/CHANGE_COLLAPSIBLE_VaLUE'

export const changeCollapsibleValue = ({ name, value }) => ({
    type: CHANGE_COLLAPSIBLE_VaLUE,
    payload: { name, value }
})



